import { render, staticRenderFns } from "./mafiaways2.vue?vue&type=template&id=0a818380"
import script from "./mafiaways2.vue?vue&type=script&lang=js"
export * from "./mafiaways2.vue?vue&type=script&lang=js"
import style0 from "./mafiaways2.vue?vue&type=style&index=0&id=0a818380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports